import { render } from "./PreavisDeleteModal.vue?vue&type=template&id=48be732e&ts=true"
import script from "./PreavisDeleteModal.vue?vue&type=script&lang=ts"
export * from "./PreavisDeleteModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__